const KEY = 'adminToken';

const payload = (token) => {
  try {
    const part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(part.padEnd(part.length + ((4 - (part.length % 4)) % 4), '=')));
  } catch (e) {
    return null;
  }
};

export const getAdminToken = () => localStorage.getItem(KEY);

export const setAdminToken = (token) => localStorage.setItem(KEY, token);

export const clearAdminToken = () => localStorage.removeItem(KEY);

export const getSession = () => {
  const token = getAdminToken();
  const p = token && payload(token);
  if (!p || !p.exp || p.exp * 1000 <= Date.now()) return null;
  return { scope: p.scope, exp: p.exp };
};

export const isUnlocked = () => getSession()?.scope === 'full';

export const OPEN_PATHS = ['/admin/payment-plans'];

export const isOpenPath = (path) => OPEN_PATHS.some((p) => path.startsWith(p));

export async function authPost(path, body) {
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getAdminToken()}` },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(typeof data.detail === 'string' ? data.detail : 'Request failed'), { status: res.status });
  setAdminToken(data.token);
  return data;
}
